import { render } from "./HistoricView.vue?vue&type=template&id=a2bfa3d6&scoped=true"
import script from "./HistoricView.vue?vue&type=script&lang=js"
export * from "./HistoricView.vue?vue&type=script&lang=js"

import "./HistoricView.vue?vue&type=style&index=0&id=a2bfa3d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2bfa3d6"]])

export default __exports__